import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper'
Swiper.use([Navigation, Pagination, Autoplay, EffectFade])

export default function facility(){
  const facilitesSlides = document.getElementById('facilitesSlides')
  if(facilitesSlides){
    const swiperParams = {
      slidesPerView: 2,
      spaceBetween: 20,
      loop: true,
      speed: 3000,
      autoplay: {
        delay: 0
      },
      1119: {
        slidesPerView: 4,
        spaceBetween: 32,
      },
      640: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
    }
    const swiper = new Swiper(facilitesSlides, swiperParams)
  }
}